import  html2pdf  from 'html2pdf.js';

export default html2pdf
